import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    [theme.breakpoints.up('md')]: {
      padding: '32px 34px'
    }
  },
  heading1: {
    marginBottom: 48
  },
  helpBox: {
    marginBottom: 48,
    padding: 32,
    [theme.breakpoints.up('md')]: {
      marginBottom: 60,
      paddingLeft: 48,
      paddingRight: 48
    }
  },
  gridSpacing: {
    paddingTop: 12,
    paddingBottom: 12
  },
  helpBoxImg: {
    display: 'block',
    margin: 'auto'
  },
  helpBoxImgWrapper: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: 240
    }
  },
  helpBoxTextWrapper: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 65
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: 65
    }
  },
  helpBoxHeader: {
    ...theme.typography.body_largeRegular,
    marginBottom: 4,
    [theme.breakpoints.up('sm')]: {
      ...theme.typography.title_smallRegular
    }
  },
  helpBoxBody: {
    ...theme.typography.body_smallRegular,
    [theme.breakpoints.up('sm')]: {
      ...theme.typography.title_smallRegular
    }
  },
  helpCenterBtnWrapper: {
    [theme.breakpoints.up('md')]: {
      flexGrow: 0,
      flexShrink: 2,
      maxWidth: 'none'
    }
  },
  helpCenterBtn: {
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  supportContactHeader: {
    ...theme.typography.title_medium,
    marginBottom: 32,
    [theme.breakpoints.up('sm')]: {
      textAlign: 'center',
      ...theme.typography.title_medium,
      marginBottom: 60
    }
  }
}));

export default useStyles;
